import {
  useConversation,
  useMarkNoReplyNeeded,
  useUndoConversationFlagClear
} from "../api/hooks";
import { showUndoToast } from "../utils/undoToast";

export const NO_REPLY_NEEDED_LABEL = "No reply needed";
export const NO_REPLY_NEEDED_TOOLTIP =
  "Nothing to answer here? Takes this conversation out of Awaiting reply for everyone on your team.";

/**
 * CRM-1931: takes a conversation out of Awaiting reply for the whole team, no
 * confirmation. Offered only while it is awaiting a reply and not escalated
 * (an escalated one has Clear flag, which clears both).
 */
export const useNoReplyNeeded = (conversationId: string) => {
  const { data } = useConversation(conversationId);
  const conversation = data?.conversation;
  const { mutateAsync, isPending } = useMarkNoReplyNeeded(conversationId);
  const { mutate: undo } = useUndoConversationFlagClear(conversationId);

  const markNoReplyNeeded = () =>
    mutateAsync()
      .then(({ clear }) =>
        showUndoToast("Marked no reply needed for everyone", () =>
          undo(clear.id)
        )
      )
      .catch(() => undefined);

  return {
    available: Boolean(conversation?.awaiting_reply && !conversation.escalated),
    isPending,
    markNoReplyNeeded
  };
};
